// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__BJBzU","left":"StickyBox_left__2Vln4","right":"StickyBox_right__36cQY"};